/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import MagicScrolls from 'magic-scrolls';
/* --------------------------------------------------
Case Study Banner
-------------------------------------------------- */

var banner = document.querySelector('.js-case-study-banner');
var image = banner.querySelector('.js-case-study-banner--image');
var colour = banner.querySelector('.js-case-study-banner--colour');
var Magic = new MagicScrolls(banner, {
  duration: 600
});
Magic.tween(image, function (value) {
  image.style.transform = "translateX(".concat(value * .25 - 20, "%) rotate(-35deg)");
  colour.style.transform = "translateY(".concat(-(value * .5) + 20, "%)"); // pattern.setAttribute('y', -value);
  // pattern.setAttribute('x', -value);
});